module.exports = __webpack_public_path__ + "img/ic_footer_social_instagram.cc08893e.svg";